import {
  getReportSummaryData,
  getReportGochiAmountsData,
  getReportGochiCountsData,
  getReportShopGochiAMountsData,
  getReportShopGroupTotalAmountData,
  getReportShopGroupByDayData,
  getReportShopGroupPlatformData,
  getReportShopGroupUserTypeData,
  getReportShopGroupByDayDownloadData,
  PostStatisticalReportDownloadData,
  getFilteredSummaryData,
  getReportShopGochiTableData,
  getGeneralReportSummaryData,
  getReportShopGroupCampaignTotalAmountData,
  getReportShopGroupCampaignByDayData,
  getReportShopGroupGochiKidTotalAmountData,
  getReportShopGroupGochiKidByDayData
} from '../libs/apis/ReportApi';

export const GET_REPORT_SUMMARY_MONTHLY_REQUEST =
  'GET_REPORT_SUMMARY_MONTHLY_REQUEST';
export const GET_REPORT_SUMMARY_MONTHLY_SUCCESS =
  'GET_REPORT_SUMMARY_MONTHLY_SUCCESS';
export const GET_REPORT_SUMMARY_MONTHLY_FAILURE =
  'GET_REPORT_SUMMARY_MONTHLY_FAILURE';

export const GET_REPORT_SUMMARY_CUMULATIVE_REQUEST =
  'GET_REPORT_SUMMARY_CUMULATIVE_REQUEST';
export const GET_REPORT_SUMMARY_CUMULATIVE_SUCCESS =
  'GET_REPORT_SUMMARY_CUMULATIVE_SUCCESS';
export const GET_REPORT_SUMMARY_CUMULATIVE_FAILURE =
  'GET_REPORT_SUMMARY_CUMULATIVE_FAILURE';

export const GET_REPORT_SUMMARY_CUSTOM_REQUEST =
  'GET_REPORT_SUMMARY_CUSTOM_REQUEST';
export const GET_REPORT_SUMMARY_CUSTOM_SUCCESS =
  'GET_REPORT_SUMMARY_CUSTOM_SUCCESS';
export const GET_REPORT_SUMMARY_CUSTOM_FAILURE =
  'GET_REPORT_SUMMARY_CUSTOM_FAILURE';

export const GET_REPORT_GOCHI_AMOUNTS_PLATFORM_REQUEST =
  'GET_REPORT_GOCHI_AMOUNTS_PLATFORM_REQUEST';
export const GET_REPORT_GOCHI_AMOUNTS_PLATFORM_SUCCESS =
  'GET_REPORT_GOCHI_AMOUNTS_PLATFORM_SUCCESS';
export const GET_REPORT_GOCHI_AMOUNTS_PLATFORM_FAILURE =
  'GET_REPORT_GOCHI_AMOUNTS_PLATFORM_FAILURE';

export const GET_REPORT_GOCHI_AMOUNTS_TYPE_REQUEST =
  'GET_REPORT_GOCHI_AMOUNTS_TYPE_REQUEST';
export const GET_REPORT_GOCHI_AMOUNTS_TYPE_SUCCESS =
  'GET_REPORT_GOCHI_AMOUNTS_TYPE_SUCCESS';
export const GET_REPORT_GOCHI_AMOUNTS_TYPE_FAILURE =
  'GET_REPORT_GOCHI_AMOUNTS_TYPE_FAILURE';

export const GET_REPORT_GOCHI_USER_COUNTS_REQUEST =
  'GET_REPORT_GOCHI_USER_COUNTS_REQUEST';
export const GET_REPORT_GOCHI_USER_COUNTS_SUCCESS =
  'GET_REPORT_GOCHI_USER_COUNTS_SUCCESS';
export const GET_REPORT_GOCHI_USER_COUNTS_FAILURE =
  'GET_REPORT_GOCHI_USER_COUNTS_FAILURE';

export const GET_REPORT_GOCHI_COUNTS_REQUEST =
  'GET_REPORT_GOCHI_COUNTS_REQUEST';
export const GET_REPORT_GOCHI_COUNTS_SUCCESS =
  'GET_REPORT_GOCHI_COUNTS_SUCCESS';
export const GET_REPORT_GOCHI_COUNTS_FAILURE =
  'GET_REPORT_GOCHI_COUNTS_FAILURE';

export const GET_REPORT_SHOP_GOCHI_AMOUNTS_REQUEST =
  'GET_REPORT_SHOP_GOCHI_AMOUNTS_REQUEST';
export const GET_REPORT_SHOP_GOCHI_AMOUNTS_SUCCESS =
  'GET_REPORT_SHOP_GOCHI_AMOUNTS_SUCCESS';
export const GET_REPORT_SHOP_GOCHI_AMOUNTS_FAILURE =
  'GET_REPORT_SHOP_GOCHI_AMOUNTS_FAILURE';

export const GET_REPORT_SHOP_GOCHI_TABLE_REQUEST =
  'GET_REPORT_SHOP_GOCHI_TABLE_REQUEST';
export const GET_REPORT_SHOP_GOCHI_TABLE_SUCCESS =
  'GET_REPORT_SHOP_GOCHI_TABLE_SUCCESS';
export const GET_REPORT_SHOP_GOCHI_TABLE_FAILURE =
  'GET_REPORT_SHOP_GOCHI_TABLE_FAILURE';

export const GET_REPORT_SHOP_GROUP_TOTAL_AMOUNTS_REQUEST =
  'GET_REPORT_SHOP_GROUP_TOTAL_AMOUNTS_REQUEST';
export const GET_REPORT_SHOP_GROUP_TOTAL_AMOUNTS_SUCCESS =
  'GET_REPORT_SHOP_GROUP_TOTAL_AMOUNTS_SUCCESS';
export const GET_REPORT_SHOP_GROUP_TOTAL_AMOUNTS_FAILURE =
  'GET_REPORT_SHOP_GROUP_TOTAL_AMOUNTS_FAILURE';

export const GET_REPORT_SHOP_GROUP_BY_DAY_AMOUNTS_REQUEST =
  'GET_REPORT_SHOP_GROUP_BY_DAY_AMOUNTS_REQUEST';
export const GET_REPORT_SHOP_GROUP_BY_DAY_AMOUNTS_SUCCESS =
  'GET_REPORT_SHOP_GROUP_BY_DAY_AMOUNTS_SUCCESS';
export const GET_REPORT_SHOP_GROUP_BY_DAY_AMOUNTS_FAILURE =
  'GET_REPORT_SHOP_GROUP_BY_DAY_AMOUNTS_FAILURE';

export const GET_REPORT_SHOP_GROUP_PLATFORM_REQUEST =
  'GET_REPORT_SHOP_GROUP_PLATFORM_REQUEST';
export const GET_REPORT_SHOP_GROUP_PLATFORM_SUCCESS =
  'GET_REPORT_SHOP_GROUP_PLATFORM_SUCCESS';
export const GET_REPORT_SHOP_GROUP_PLATFORM_FAILURE =
  'GET_REPORT_SHOP_GROUP_PLATFORM_FAILURE';

export const GET_REPORT_SHOP_GROUP_USER_TYPE_REQUEST =
  'GET_REPORT_SHOP_GROUP_USER_TYPE_REQUEST';
export const GET_REPORT_SHOP_GROUP_USER_TYPE_SUCCESS =
  'GET_REPORT_SHOP_GROUP_USER_TYPE_SUCCESS';
export const GET_REPORT_SHOP_GROUP_USER_TYPE_FAILURE =
  'GET_REPORT_SHOP_GROUP_USER_TYPE_FAILURE';

export const GET_REPORT_SHOP_GROUP_BY_DAY_DOWNLOAD_REQUEST =
  'GET_REPORT_SHOP_GROUP_BY_DAY_DOWNLOAD_REQUEST';
export const GET_REPORT_SHOP_GROUP_BY_DAY_DOWNLOAD_SUCCESS =
  'GET_REPORT_SHOP_GROUP_BY_DAY_DOWNLOAD_SUCCESS';
export const GET_REPORT_SHOP_GROUP_BY_DAY_DOWNLOAD_FAILURE =
  'GET_REPORT_SHOP_GROUP_BY_DAY_DOWNLOAD_FAILURE';

export const GET_FILTERED_REPORT_SUMMARY_REQUEST =
  'GET_FILTERED_REPORT_SUMMARY_REQUEST';
export const GET_FILTERED_REPORT_SUMMARY_SUCCESS =
  'GET_FILTERED_REPORT_SUMMARY_SUCCESS';
export const GET_FILTERED_REPORT_SUMMARY_FAILURE =
  'GET_FILTERED_REPORT_SUMMARY_FAILURE';

export const GET_GENERAL_REPORT_SUMMARY_REQUEST =
  'GET_GENERAL_REPORT_SUMMARY_REQUEST';
export const GET_GENERAL_REPORT_SUMMARY_SUCCESS =
  'GET_GENERAL_REPORT_SUMMARY_SUCCESS';
export const GET_GENERAL_REPORT_SUMMARY_FAILURE =
  'GET_GENERAL_REPORT_SUMMARY_FAILURE';

export const POST_STATISTICAL_REPORT_DOWNLOAD_REQUEST =
  'POST_STATISTICAL_REPORT_DOWNLOAD_REQUEST';
export const POST_STATISTICAL_REPORT_DOWNLOAD_SUCCESS =
  'POST_STATISTICAL_REPORT_DOWNLOAD_SUCCESS';
export const POST_STATISTICAL_REPORT_DOWNLOAD_FAILURE =
  'POST_STATISTICAL_REPORT_DOWNLOAD_FAILURE';

export const getReportSummaryForMonthly = params => dispatch => {
  dispatch({ type: GET_REPORT_SUMMARY_MONTHLY_REQUEST });
  return getReportSummaryData(params)
    .then(response =>
      dispatch({
        type: GET_REPORT_SUMMARY_MONTHLY_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_REPORT_SUMMARY_MONTHLY_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getGeneralReportSummary = params => dispatch => {
  dispatch({ type: GET_GENERAL_REPORT_SUMMARY_REQUEST });
  return getGeneralReportSummaryData(params)
    .then(response =>
      dispatch({
        type: GET_GENERAL_REPORT_SUMMARY_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GENERAL_REPORT_SUMMARY_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getReportSummaryForCumulative = params => dispatch => {
  dispatch({ type: GET_REPORT_SUMMARY_CUMULATIVE_REQUEST });
  return getReportSummaryData(params)
    .then(response =>
      dispatch({
        type: GET_REPORT_SUMMARY_CUMULATIVE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_REPORT_SUMMARY_CUMULATIVE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getReportSummaryForCustom = params => dispatch => {
  dispatch({ type: GET_REPORT_SUMMARY_CUSTOM_REQUEST });
  return getReportSummaryData(params)
    .then(response =>
      dispatch({
        type: GET_REPORT_SUMMARY_CUSTOM_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_REPORT_SUMMARY_CUSTOM_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getFilteredReportSummary = params => dispatch => {
  dispatch({ type: GET_FILTERED_REPORT_SUMMARY_REQUEST });
  return getFilteredSummaryData(params)
    .then(response =>
      dispatch({
        type: GET_FILTERED_REPORT_SUMMARY_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_FILTERED_REPORT_SUMMARY_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getReportGochiAmountsForPlatform = params => dispatch => {
  dispatch({ type: GET_REPORT_GOCHI_AMOUNTS_PLATFORM_REQUEST });
  return getReportGochiAmountsData(params)
    .then(response =>
      dispatch({
        type: GET_REPORT_GOCHI_AMOUNTS_PLATFORM_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_REPORT_GOCHI_AMOUNTS_PLATFORM_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getReportGochiAmountsForType = params => dispatch => {
  dispatch({ type: GET_REPORT_GOCHI_AMOUNTS_TYPE_REQUEST });
  return getReportGochiAmountsData(params)
    .then(response =>
      dispatch({
        type: GET_REPORT_GOCHI_AMOUNTS_TYPE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_REPORT_GOCHI_AMOUNTS_TYPE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getReportGochiUserCounts = params => dispatch => {
  dispatch({ type: GET_REPORT_GOCHI_USER_COUNTS_REQUEST });
  return getReportGochiCountsData(params)
    .then(response =>
      dispatch({
        type: GET_REPORT_GOCHI_USER_COUNTS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_REPORT_GOCHI_USER_COUNTS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getReportGochiCounts = params => dispatch => {
  dispatch({ type: GET_REPORT_GOCHI_COUNTS_REQUEST });
  return getReportGochiCountsData(params)
    .then(response =>
      dispatch({
        type: GET_REPORT_GOCHI_COUNTS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_REPORT_GOCHI_COUNTS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getReportShopGochiAmounts = params => dispatch => {
  dispatch({ type: GET_REPORT_SHOP_GOCHI_AMOUNTS_REQUEST });
  return getReportShopGochiAMountsData(params)
    .then(response =>
      dispatch({
        type: GET_REPORT_SHOP_GOCHI_AMOUNTS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_REPORT_SHOP_GOCHI_AMOUNTS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getReportShopGochiTable = params => dispatch => {
  dispatch({ type: GET_REPORT_SHOP_GOCHI_TABLE_REQUEST });
  return getReportShopGochiTableData(params)
    .then(response =>
      dispatch({
        type: GET_REPORT_SHOP_GOCHI_TABLE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_REPORT_SHOP_GOCHI_TABLE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getReportShopGroupTotalAmount = params => dispatch => {
  dispatch({ type: GET_REPORT_SHOP_GROUP_TOTAL_AMOUNTS_REQUEST });
  return getReportShopGroupTotalAmountData(params)
    .then(response =>
      dispatch({
        type: GET_REPORT_SHOP_GROUP_TOTAL_AMOUNTS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_REPORT_SHOP_GROUP_TOTAL_AMOUNTS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getReportShopGroupByDayAmount = params => dispatch => {
  dispatch({ type: GET_REPORT_SHOP_GROUP_BY_DAY_AMOUNTS_REQUEST });
  return getReportShopGroupByDayData(params)
    .then(response =>
      dispatch({
        type: GET_REPORT_SHOP_GROUP_BY_DAY_AMOUNTS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_REPORT_SHOP_GROUP_BY_DAY_AMOUNTS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getReportShopGroupPlatForm = params => dispatch => {
  dispatch({ type: GET_REPORT_SHOP_GROUP_PLATFORM_REQUEST });
  return getReportShopGroupPlatformData(params)
    .then(response =>
      dispatch({
        type: GET_REPORT_SHOP_GROUP_PLATFORM_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_REPORT_SHOP_GROUP_PLATFORM_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getReportShopGroupByUserType = params => dispatch => {
  dispatch({ type: GET_REPORT_SHOP_GROUP_USER_TYPE_REQUEST });
  return getReportShopGroupUserTypeData(params)
    .then(response =>
      dispatch({
        type: GET_REPORT_SHOP_GROUP_USER_TYPE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_REPORT_SHOP_GROUP_USER_TYPE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getReportShopGroupByDayDownload = params => dispatch => {
  dispatch({ type: GET_REPORT_SHOP_GROUP_BY_DAY_AMOUNTS_REQUEST });
  return getReportShopGroupByDayDownloadData(params)
    .then(response =>
      dispatch({
        type: GET_REPORT_SHOP_GROUP_BY_DAY_DOWNLOAD_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_REPORT_SHOP_GROUP_BY_DAY_DOWNLOAD_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const PostStatisticalReportDownload = params => dispatch => {
  dispatch({ type: POST_STATISTICAL_REPORT_DOWNLOAD_REQUEST });
  return PostStatisticalReportDownloadData(params)
    .then(response =>
      dispatch({
        type: POST_STATISTICAL_REPORT_DOWNLOAD_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: POST_STATISTICAL_REPORT_DOWNLOAD_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getReportShopGroupCampaignTotalAmount = params => dispatch => {
  dispatch({ type: GET_REPORT_SHOP_GROUP_TOTAL_AMOUNTS_REQUEST });
  return getReportShopGroupCampaignTotalAmountData(params)
    .then(response =>
      dispatch({
        type: GET_REPORT_SHOP_GROUP_TOTAL_AMOUNTS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_REPORT_SHOP_GROUP_TOTAL_AMOUNTS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getReportShopGroupCampaignByDayAmount = params => dispatch => {
  dispatch({ type: GET_REPORT_SHOP_GROUP_BY_DAY_AMOUNTS_REQUEST });
  return getReportShopGroupCampaignByDayData(params)
    .then(response =>
      dispatch({
        type: GET_REPORT_SHOP_GROUP_BY_DAY_AMOUNTS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_REPORT_SHOP_GROUP_BY_DAY_AMOUNTS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getReportShopGroupGochiKidTotalAmount = params => dispatch => {
  dispatch({ type: GET_REPORT_SHOP_GROUP_TOTAL_AMOUNTS_REQUEST });
  return getReportShopGroupGochiKidTotalAmountData(params)
    .then(response =>
      dispatch({
        type: GET_REPORT_SHOP_GROUP_TOTAL_AMOUNTS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_REPORT_SHOP_GROUP_TOTAL_AMOUNTS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getReportShopGroupGochiKidByDayAmount = params => dispatch => {
  dispatch({ type: GET_REPORT_SHOP_GROUP_BY_DAY_AMOUNTS_REQUEST });
  return getReportShopGroupGochiKidByDayData(params)
    .then(response =>
      dispatch({
        type: GET_REPORT_SHOP_GROUP_BY_DAY_AMOUNTS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_REPORT_SHOP_GROUP_BY_DAY_AMOUNTS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};
